import { addMinutes as addMinutesFns } from 'date-fns';

export default function addMinutes(date: Date, minutes: number): Date {
  return addMinutesFns(date, minutes);
}
